// import { useEffect, useMemo, useState } from "react";
// import { FaBoxOpen } from "react-icons/fa";
// import { Link } from "react-router-dom";
// import API from "../../../utils/api";
// import { filterVisibleCategories } from "../../../utils/categoryFilters";
// import SliderComp from "../../../components/SliderComp";
// import classes from "./Section1.module.css";

// const RANDOM_DESC = [
//   "Top quality products.",
//   "Best-selling category.",
//   "Trusted by professionals.",
//   "Reliable performance.",
//   "High durability guaranteed.",
//   "Engineered for excellence.",
//   "Perfect for everyday use.",
//   "Customer favorite selection.",
//   "Built to last longer.",
//   "Exceptional value for money.",
//   "Crafted with precision.",
//   "Performance you can trust.",
//   "Highly recommended by experts.",
//   "Designed for maximum efficiency.",
//   "A smart choice for everyone.",
//   "Premium build and finish.",
//   "Innovation meets quality.",
//   "Made for long-term usage.",
//   "Superior functionality assured.",
//   "One of our top-rated picks.",
//   "Outstanding user satisfaction.",
//   "Great choice for professionals.",
//   "Tested for optimal results.",
//   "Modern, sleek, and reliable.",
//   "Quality checked and verified.",
// ];

// export default function Section1() {
//   const [categories, setCategories] = useState([]);

//   useEffect(() => {
//     async function fetchCategories() {
//       try {
//         const response = await API.post("/categories.php", { action: "fetch" });
//         const payload = Array.isArray(response.data)
//           ? response.data
//           : response.data?.data || [];

//         const visible = filterVisibleCategories(payload).map((item) => ({
//           ...item,
//           description:
//             item.description && item.description.trim() !== ""
//               ? item.description
//               : RANDOM_DESC[Math.floor(Math.random() * RANDOM_DESC.length)],
//         }));

//         setCategories(visible);
//       } catch (err) {
//         console.error("Error loading categories:", err);
//         setCategories([]);
//       }
//     }
//     fetchCategories();
//   }, []);

//   return (
//     <div className={classes.section1Wrapper}>
//       <div className={classes.section1Container}>
//         <div className={classes.headingWrapper}>
//           <div className={classes.line}></div>
//           <h2 className={classes.heading}>Shop By Category</h2>
//           <div className={classes.line}></div>
//         </div>

//         {categories.length > 0 && (
//           <SliderComp slidesToShow={5}>
//             {categories.map((item, idx) => (
//               <div className={classes.slideItem} key={idx}>
//                 <div className={classes.section1Content}>
//                   <div className={classes.section1Heading}>
//                     <h3>{item.categoryName}</h3>
//                     <p>{item.description}</p>
//                     <Link
//                       to={
//                         item.category_slug
//                           ? `/category/${item.category_slug}`
//                           : "/shop"
//                       }
//                     >
//                       View Category
//                     </Link>
//                   </div>

//                   <div
//                     className={classes.section1Image}
//                     style={{ background: "#a0d4ff61" }}
//                   >
//                     <FaBoxOpen />
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </SliderComp>
//         )}
//       </div>
//     </div>
//   );
// }

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../../../utils/api";
import { filterVisibleCategories } from "../../../utils/categoryFilters";
import SliderComp from "../../../components/SliderComp";
import classes from "./Section1.module.css";

// Categories to fetch and show
const ALLOWED_CATEGORIES = [
  "Internal SSDs",
  "Memory",
  "Accessories & Batteries",
  "Power Supplies",
  "Network Switches",
  "Motherboards",
  "CPUs & Processors",
  "Graphic Cards",
];

// Map custom images to categories
const cateImg = {
  "Internal SSDs": "../cate-img/ssd.png",
  Memory: "../cate-img/memory.png",
  "Accessories & Batteries": "../cate-img/batteries.png",
  "Power Supplies": "../cate-img/power-supplies.png",
  "Network Switches": "../cate-img/network-switches.png",
  Motherboards: "../cate-img/motherboards.png",
  "CPUs & Processors": "../cate-img/cpu-processor.png",
  "Graphic Cards": "../cate-img/graphic-card.png",
};

const RANDOM_DESC = [
  "Top quality products.",
  "Best-selling category.",
  "Trusted by professionals.",
  "Reliable performance.",
  "High durability guaranteed.",
  "Engineered for excellence.",
  "Perfect for everyday use.",
  "Customer favorite selection.",
  "Built to last longer.",
  "Exceptional value for money.",
  "Crafted with precision.",
  "Performance you can trust.",
  "Highly recommended by experts.",
  "Designed for maximum efficiency.",
  "A smart choice for everyone.",
  "Premium build and finish.",
  "Innovation meets quality.",
  "Made for long-term usage.",
  "Superior functionality assured.",
  "One of our top-rated picks.",
  "Outstanding user satisfaction.",
  "Great choice for professionals.",
  "Tested for optimal results.",
  "Modern, sleek, and reliable.",
  "Quality checked and verified.",
];

export default function Section1() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    async function fetchCategories() {
      try {
        const response = await API.post("/categories.php", { action: "fetch" });
        const payload = Array.isArray(response.data)
          ? response.data
          : response.data?.data || [];

        // Filter only the allowed categories
        const filtered = filterVisibleCategories(payload)
          .filter((item) => ALLOWED_CATEGORIES.includes(item.categoryName))
          .map((item) => ({
            ...item,
            description:
              item.description && item.description.trim() !== ""
                ? item.description
                : RANDOM_DESC[Math.floor(Math.random() * RANDOM_DESC.length)],
            image: cateImg[item.categoryName] || null,
          }));

        setCategories(filtered);
      } catch (err) {
        console.error("Error loading categories:", err);
        setCategories([]);
      }
    }
    fetchCategories();
  }, []);

  return (
    <div className={classes.section1Wrapper}>
      <div className={classes.section1Container}>
        <div className={classes.headingWrapper}>
          <div className={classes.line}></div>
          <h2 className={classes.heading}>Shop By Category</h2>
          <div className={classes.line}></div>
        </div>

        {categories.length > 0 && (
          <SliderComp slidesToShow={5}>
            {categories.map((item, idx) => (
              <div className={classes.slideItem} key={idx}>
                <div className={classes.section1Content}>
                  <div className={classes.section1Heading}>
                    <h3>{item.categoryName}</h3>
                    <p>{item.description}</p>
                    <Link
                      to={
                        item.category_slug
                          ? `/category/${item.category_slug}`
                          : "/shop"
                      }
                    >
                      View Category
                    </Link>
                  </div>

                  <div className={classes.section1Image}>
                    {item.image ? (
                      <img
                        src={item.image}
                        alt={item.categoryName}
                        className={classes.cateImg}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            ))}
          </SliderComp>
        )}
      </div>
    </div>
  );
}
